import React from 'react';
import { Card, List } from 'antd';

import UploadFile from 'components/UploadAttachment/UploadFile';
import ExportFile from './ExportFile';

/**
 * UploadFiles Component need this type of data to match correctly.
 * LayerList should be array with title / endpoint / fileType and layerId properties.
 */
const layerList = [
  {
    title: 'Chemins',
    endpoint: '/layer/chemins/shapefile/',
    fileType: 'shapefile',
    layerId: 'chemins',
  },
  {
    title: 'Hors chemins',
    endpoint: '/layer/hors_chemins/shapefile/',
    fileType: 'shapefile',
    layerId: 'hors_chemins',
  },
  {
    title: 'Parkings',
    endpoint: '/layer/parkings/shapefile/',
    fileType: 'shapefile',
    layerId: 'parkings',
  },
  {
    title: 'Zones de triage',
    endpoint: '/layer/triages/shapefile/',
    fileType: 'shapefile',
    layerId: 'triages',
  },
  {
    title: 'Forêts',
    endpoint: '/layer/forets/shapefile/',
    fileType: 'shapefile',
    layerId: 'forets',
  },
];

export const UploadFiles = () => (
  <Card title="Exporter / importer les données cartographiques">
    <List
      itemLayout="horizontal"
      dataSource={layerList}
      renderItem={item => (
        <List.Item>
          <List.Item.Meta
            title={<p><strong>{item.title}</strong></p>}
            description={(
              <div style={{ display: 'flex' }}>
                <ExportFile layerId={item.layerId} />
                <UploadFile fileType={item.fileType} endpoint={item.endpoint} />
              </div>
            )}
          />
        </List.Item>
      )}
    />
  </Card>
);

export default UploadFiles;



// WEBPACK FOOTER //
// ./src/components/Admin/UploadFiles/index.js